import { render } from "./VsudSelectSearch.vue?vue&type=template&id=13b47cdd&scoped=true"
import script from "./VsudSelectSearch.vue?vue&type=script&lang=js"
export * from "./VsudSelectSearch.vue?vue&type=script&lang=js"

import "./VsudSelectSearch.vue?vue&type=style&index=0&id=13b47cdd&scoped=true&lang=css"
import "./VsudSelectSearch.vue?vue&type=style&index=1&id=13b47cdd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b47cdd"]])

export default __exports__